import { AccessoryCategoryCard } from '@coolblue-development/next-patterns/client';
import { accessoryFragment } from '@features/accessory-categories/queries';
import { AccessoryEntrance } from '@features/accessory-categories/types';
import { readFragment } from 'src/graphql';

export function AccessoryCard({
  fragment,
  url,
  totalCategories,
  index
}: AccessoryEntrance & { index: number }) {
  const accessory = readFragment(accessoryFragment, fragment);

  const href = url ?? '';
  const imageId = Number(accessory.product?.primaryImage.id ?? '0');
  const productTypeId = Number(accessory.product?.productType.productTypeId ?? '0');

  return (
    <AccessoryCategoryCard
      href={href}
      imageId={imageId}
      categoryName={accessory.categoryName}
      numberOfProducts={accessory.productCount}
      totalCategories={totalCategories}
      productTypeId={productTypeId}
      index={index}
      linkProps={{ rel: 'nofollow' }}
    />
  );
}
